import request from '@/utils/request'
import {AxiosResponse} from 'axios';
import * as _ from 'lodash';
import auth_service from "@/services/auth_service";

export class Item {
  name: string;
  display: string;
}

class FillBlocks {
  ok_hn_blocks: Item[];
  purchase_blocks: Item[];
  sale_blocks: Item[];
  transport_costs_blocks: Item[];
  transport_income_blocks: Item[];
}

export type FillBlocksRespKey = keyof FillBlocks;

class FillBlocksRespSchema {
  data: FillBlocks
}

// Перечень ключей блоков заполнения данных
const fillBlockKeys = ['_ok_hn_blocks', '_sale_blocks', '_purchase_blocks',
  '_transport_costs_blocks', '_transport_income_blocks'] as const;

// Тип ключей блоков заполнения данных в виде юниона
export type FillBlockKey = typeof fillBlockKeys[number];

class DictsCacheService {

  private _all_caches: any = {
    fill_blocks: [],
    period: [],
    period_simple: [],
    cuts: []
  };


  async update_dicts_cache() {

    if (auth_service.getToken().length === 0) {
      return
    }

    let keys_: string[] = ['period', 'heat_carrier'];
    for (let k of keys_) {
      this.loadFromLocalStarage(k);
    }
    // if (this._all_caches.period.length > 12) {
    //   this._all_caches.period_simple = this._all_caches.period.slice(0, 13)
    // }
    this._all_caches.period_simple = this._all_caches.period

    await Promise.all([
      this.loadDict('period'),
      this.loadDict('heat_carrier'),
      this.loadFillBlocks(),
      this.loadCuts(),
    ])
    this._all_caches.period_simple = this._all_caches.period
    // if (this._all_caches.period.length > 12) {
    //   this._all_caches.period_simple = this._all_caches.period.slice(0, 13)
    // }

  }


  loadFromLocalStarage(cache_key: string) {
    let cache = localStorage.getItem(cache_key);
    if (cache) {
      try {
        this._all_caches[cache_key] = JSON.parse(cache);
      } catch (e) {
        this._all_caches[cache_key] = [];
      }
    }
    cache = localStorage.getItem(`${cache_key}_dict`);
    if (cache) {
      try {
        this._all_caches[`${cache_key}_dict`] = JSON.parse(cache);
      } catch (e) {
        this._all_caches[`${cache_key}_dict`] = {};
      }
    }
  }

  async cacheToDict(cache_key: string): Promise<void> {
    try {

      if (this._all_caches[cache_key]) {

        this._all_caches[`${cache_key}_dict`] = {};

        this._all_caches[cache_key].forEach((x: any) => {
          this._all_caches[`${cache_key}_dict`][x.id] = x;
        })

        localStorage.setItem(`${cache_key}_dict`, JSON.stringify(this._all_caches[`${cache_key}_dict`]));

      } else {
        //
      }
    } catch (e) {
      console.error(e);
    }
  }

  async loadDict(cache_key: string): Promise<void> {
    try {
      const resp: AxiosResponse['data'] = await request({
        url: `dicts/${cache_key}`,
        method: 'get'
      });

      if (resp && resp.data) {
        this._all_caches[cache_key] = _.clone(resp.data);
        localStorage.setItem(cache_key, JSON.stringify(this._all_caches[cache_key]));

      } else {

      }
    } catch (e) {
      console.error(e);
    }
  }

  async loadCuts(): Promise<void> {
    try {
      let url = 'cut';
      if (auth_service.isAdmin && auth_service.isAdmin()) {
        url = '/cut/for_admin';
      }
      const resp: AxiosResponse["data"] = await request({
        url: url,
        method: 'get'
      });
      if (resp?.data) {
        this._all_caches.cuts = _.clone(resp?.data)
      } else {
        this._all_caches.cuts = [];
      }
    } catch (e) {
      this._all_caches.cuts = [];
    }
    localStorage.setItem('cuts_cache', JSON.stringify(this._all_caches.cuts));
  }

  async loadFillBlocks(): Promise<void> {
    let cache: any = null;

    for (let b of fillBlockKeys) {
      cache = localStorage.getItem(b);
      if (cache) {
        try {
          this._all_caches.fill_blocks[b] = JSON.parse(cache);
        } catch (e) {
          this._all_caches.fill_blocks[b] = [];
        }
      }
    }

    const resp: FillBlocksRespSchema = await request({
      url: `dicts/fill_blocks`,
      method: 'get'
    });

    if (resp && resp.data) {
      this._all_caches.fill_blocks._ok_hn_blocks = _.clone(resp.data.ok_hn_blocks);
      this._all_caches.fill_blocks._sale_blocks = _.clone(resp.data.sale_blocks);
      this._all_caches.fill_blocks._purchase_blocks = _.clone(resp.data.purchase_blocks);
      this._all_caches.fill_blocks._transport_costs_blocks = _.clone(resp.data.transport_costs_blocks);
      this._all_caches.fill_blocks._transport_income_blocks = _.clone(resp.data.transport_income_blocks);

      for (let b of fillBlockKeys) {
        localStorage.setItem(b, JSON.stringify(this._all_caches.fill_blocks[b]));
      }

    } else {

    }
  }

  public get periods() {
    return this._all_caches.period;
  }

  public get periods_simple() {
    return this._all_caches.period_simple;
  }

  public get heat_carrier() {
    return this._all_caches.heat_carrier;
  }

  public get ok_hn_blocks() {
    return this._all_caches.fill_blocks._ok_hn_blocks;
  }

  public get sale_blocks() {
    return this._all_caches.fill_blocks._sale_blocks;
  }

  public get purchase_blocks() {
    return this._all_caches.fill_blocks._purchase_blocks;
  }

  public get transport_costs_blocks() {
    return this._all_caches.fill_blocks._transport_costs_blocks;
  }

  public get transport_income_blocks() {
    return this._all_caches.fill_blocks._transport_income_blocks;
  }

  public get cuts() {
    return this._all_caches.cuts;
  }

}

export default new DictsCacheService();
